import { clsx, type ClassValue } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

// Handle custom class groups from index.css
const customTwMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      'font-size': [
        // Caption
        'text-caption-regular',
        'text-caption-bold',

        // Body
        'text-body-s-regular',
        'text-body-s-semibold',
        'text-body-s-bold',
        'text-body-m-regular',
        'text-body-m-semibold',
        'text-body-m-bold',

        // Heading
        'text-heading-s-medium',
        'text-heading-s-bold',
        'text-heading-m-medium',
        'text-heading-m-bold',
        'text-heading-l-semibold',
        'text-heading-l-bold',
        'text-heading-xl-semibold',
        'text-heading-xl-bold',
        'text-heading-2xl-semibold',
        'text-heading-2xl-bold',
        'text-heading-3xl-regular',
        'text-heading-3xl-bold',

        // Link
        'text-link-s-regular',
        'text-link-s-bold',
        'text-link-m-regular',
        'text-link-m-bold',
      ],
    },
  },
});

export function cn(...inputs: ClassValue[]) {
  return customTwMerge(clsx(inputs));
}
